import { IllustrativeIcon, Txt } from '@vst/beam';
import { Alert } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { CustomDecorativeModal } from '@app/components/Modal';
import { useScreenResolution } from '@app/hooks';

type BrowseNoOffersProps = {
  isModalOpen: boolean;
  handleClose: () => void;
};

const BrowseNoOffers = ({ isModalOpen, handleClose }: BrowseNoOffersProps): JSX.Element => {
  const { t } = useTranslation('BuyMore');

  const { isSmall, isExtraSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall;

  return (
    <CustomDecorativeModal
      header={t('Browse.noOffers.title')}
      isOpen={isModalOpen}
      data-cy="outcome-buy-more-no-offers"
      actions={{
        primary: {
          label: t('Browse.error.buttons.close'),
          onClick: handleClose,
          'data-cy': 'buy-more-close-no-offers',
        },
      }}
      onClose={handleClose}
      icon={<IllustrativeIcon icon={Alert} color="teal_600" />}
    >
      <Txt color="subtle" variant={isMobile ? 'bodySmallRegular' : 'bodyLargeRegular'}>
        {t('Browse.noOffers.description')}
      </Txt>
    </CustomDecorativeModal>
  );
};

export default BrowseNoOffers;
